import React from 'react';
import {HtmlParse} from 'utils';

const SuccessIcon = () => {
    const icon = `<svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72">
        <g fill="none" fill-rule="nonzero" transform="translate(2 2)">
            <circle cx="34" cy="34" r="34" stroke="#A4C735" stroke-width="4"/>
            <path fill="#A4C735" d="M51.377 28.557l-18.94 19.787c-.07.07-.147.143-.219.223-.065.08-.128.119-.172.165-.276.254-.552.46-.791.652-.03.027-.03 0-.03.027-.274.17-.518.317-.79.393-.25.094-.512.155-.774.196h-.367a3.544 3.544 0 0 1-1.991-.74 1.1 1.1 0 0 1-.16-.119c-.188-.09-.311-.247-.462-.375a2.252 2.252 0 0 1-.195-.202l-8.871-9.257c-1.11-1.166-1.65-2.265-1.613-3.298.03-1.05.47-1.976 1.32-2.86.812-.865 1.762-1.348 2.757-1.399.965-.043 2.038.534 3.15 1.684l6.142 6.41L45.78 22.7c1.098-1.167 2.17-1.74 3.168-1.698.966.032 1.887.505 2.727 1.382.815.88 1.29 1.822 1.323 2.85.03 1.045-.51 2.139-1.622 3.32v.003z"/>
        </g>
    </svg>`;

    return (
        <span>{HtmlParse(icon)}</span>
    )
}

export default SuccessIcon;